import { render } from "./EntriesCarousel.vue?vue&type=template&id=509d4461&scoped=true"
import script from "./EntriesCarousel.vue?vue&type=script&lang=js"
export * from "./EntriesCarousel.vue?vue&type=script&lang=js"

import "./EntriesCarousel.vue?vue&type=style&index=0&id=509d4461&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509d4461"]])

export default __exports__